// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsDataAppModule } from './app.module';
bootstrapAppModule(MutualFundsDataAppModule);
